/*
 * 作品案例搜索页
 * @author: linbenjian
 * @date: 2018-07-12 18:46:32
 */
import '../global/global';

import CaseSearch from 'containers/app-case/case-search';
import '@fe/common/lib/base.css';
import './app-case-search.less';
import { initSSO } from 'components/sso/sso';
import React from 'react';
import ReactDOM from 'react-dom';
import store from 'store';
import { Provider } from 'react-redux';
import { enableHMR } from 'utils/common';

// 初始化登陆信息后再渲染页面
initSSO(() => {
  ReactDOM.hydrate(
    <Provider store={store}>
      <CaseSearch />
    </Provider>,
    document.getElementById('container')
  );
});

enableHMR(module);
